import React from 'react';
import TextField from '@mui/material/TextField';
import SearchRounded from '@mui/icons-material/SearchRounded';
import InputAdornment from '@mui/material/InputAdornment';
import Container from '@mui/material/Container';
import { useNavigate } from "react-router-dom";

export default function SearchBar(props:any) {

  let navigate = useNavigate();

  const [searchValue, setSearchValue] = React.useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const handleKeyPress = (event: any) => {
    if(event.key === 'Enter')
    {
      navigate(`/browse?filter=${searchValue}`);
      event.preventDefault();
    }
  };

  return (
      <Container>
            <TextField
              label="Quick Search"
              size="medium"
              value={searchValue}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchRounded />
                  </InputAdornment>

                ),
              }}
              style={{width:"60%", backgroundColor:"white", marginTop: "5px", marginBottom:"5px"}}
            >
            </TextField>
            <br/>
            <span style={{fontSize:"12px"}}>Enter a <b>Vista ID</b> (e.g. hs72.0 or hs2766), a <b>flanking gene name</b> (e.g. IRF8) or <b>element coordinates</b> (e.g. chr16:86396481-86397120).</span>

      </Container>
  );
}
